import helper from './../classes/helper';
import Base from './base';
import _ from 'lodash';
import settings from './../classes/settings';

export default class User extends Base {
    static searchConfig = [{
        'icon': 'mdi-format-text',
        'label': 'Naam/E-mail',
        'type': 'search',
    },
    {
        'icon': 'mdi-format-text',
        'label': 'Rol',
        'type': 'roles',
        settings: {
            roles: settings.roles
        },
        'filter': 'roleNames'
    },
    {
        icon: 'mdi-calendar',
        label: 'Aanmaakdatum',
        type: 'date-between',
        filter: 'createdAt'
    },
    ];
    static exportFilters = {
        isActive: false,
        enabled: true,
        roleNames: ['member', 'admin', 'lead']
    }
    static itemName = 'User';
    static exportFields = ['id', 'name', 'isSuper', 'firstName', 'lastName', 'username', 'email', 'assignedRealmRoles{id name}', 'attributes{phone_number, jobtitle nickname birthdate gender locality locale iban bic postal_code street_address region country notes extra_email extra_phone description}'];
    static moduleName = 'users';

    constructor(item) {
        super(item);
        if (item) {
            for (const key in item) {
                if (item.hasOwnProperty(key)) {
                    if (key == 'attributes') {
                        if (!this.attributes) {
                            this.attributes = {};
                        }

                        for (const prop in item[key]) {
                            if (item[key].hasOwnProperty(prop)) {
                                this[key][prop] = item[key][prop];
                                if (item[key][prop] == null) {
                                    delete this[key][prop];
                                }
                            }
                        }
                    } else if (key == 'assignedRealmRoles' || key == 'roles') {
                        let roles = [];
                        if (item[key]) {
                            let count = item[key].length;
                            for (let i = 0; i < count; i++) {
                                const role = item[key][i];
                                if (!settings.roles.exception.includes(role.name)) {
                                    roles.push(role);
                                }
                            }
                        }

                        this[key] = roles;
                    } else {
                        this[key] = item[key];
                    }
                }
            }
        }
    }
    static fromJWT(token, organizationId) {
        /*axios.defaults.headers.common = {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json',
        }*/

        const data = this.parseJwt(token);

        let realmRoles = [];
        for (let i = 0; i < data.realm_access.roles.length; i++) {
            const roleName = data.realm_access.roles[i];
            realmRoles.push({
                name: roleName
            });
        }

        return new this({
            id: data.sub,
            firstName: data.given_name,
            lastName: data.family_name,
            email: data.email,
            username: data.preferred_username,
            assignedRealmRoles: realmRoles,
            organization: {
                id: organizationId
            }
        });
    }
    static parseJwt(token) {
        var base64Url = token.split('.')[1];
        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
        var jsonPayload = decodeURIComponent(window.atob(base64).split('').map(function (c) {
            return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
        }).join(''));

        return JSON.parse(jsonPayload);
    }

    PERMISSIONS = {};
    can(action) {
        if (this.PERMISSIONS[action]) {
            return this.PERMISSIONS[action];
        }

        const myRole = this.getRole().name;
        if (myRole == 'root') {
            this.PERMISSIONS[action] = true;
            return true;
        }

        if (this.organization.configuration && this.organization.configuration.settings) {
            for (let i = 0; i < this.organization.configuration.settings.length; i++) {
                const setting = this.organization.configuration.settings[i];
                if (setting.key == 'permission.' + action) {
                    const permitted = JSON.parse(setting.value);
                    for (let j = 0; j < permitted.length; j++) {
                        const permittedRole = permitted[j];
                        if (permittedRole == myRole) {
                            this.PERMISSIONS[action] = true;
                            return true;
                        }
                    }
                }
            }
        }

        this.PERMISSIONS[action] = false;
        return false;
    }
    // Aanmaken of aanpassen mag enkel voor gebruikers met een lagere rol dan de eigen rol (een beheerder
    // ook voor andere beheerders, zie settings.filterManageableRoleNames), en voor zichzelf.
    // Leest de rollen rechtstreeks uit: getRole() cachet en volgt een rolwijziging in een formulier niet.
    canManageUser(user) {
        if (user.id && user.id == this.id) {
            return true;
        }

        const ownRole = this.getRole();
        const roleNames = (user.assignedRealmRoles || []).filter(role => role).map(role => role.name);
        return settings.filterManageableRoleNames(roleNames, ownRole ? ownRole.name : null).length == roleNames.length;
    }
    MY_GROUP = null
    getRoleGroup() {
        if (this.MY_GROUP) {
            return this.MY_GROUP;
        }

        for (const group in settings.roles) {
            if (Object.hasOwnProperty.call(settings.roles, group)) {
                const groups = settings.roles[group];
                if (groups.includes(this.getRole().name)) {
                    this.MY_GROUP = group;
                    return this.MY_GROUP;
                }
            }
        }

        return null;
    }
    getGroupsString() {
        let str_groups = '';
        if (this.groups) {
            for (let i = 0; i < this.groups.length; i++) {
                const group = this.groups[i];
                str_groups += group.name;
                if (i < this.groups.length - 1) {
                    str_groups += ', ';
                }
            }
        }

        return str_groups;
    }
    set organizationId(organizationId) {
        if (!this.organization) {
            this.organization = {};
        }
        this.organization.id = organizationId;
    }
    get organizationId() {
        return this.organization.id;
    }
    MY_ROLE = null

    // Only root may write or preview SQL in query templates; eodobjects enforces the same.
    isRoot() {
        const role = this.getRole();
        return Boolean(role && role.name == 'root');
    }

    getRole() {
        if (this.MY_ROLE) {
            return this.MY_ROLE;
        }

        if (!this.assignedRealmRoles) {
            return null;
        }

        let roles = this.assignedRealmRoles;

        for (let i = 0; i < roles.length; i++) {
            for (const roleGroup in settings.roles) {
                const checkRoles = settings.roles[roleGroup];
                if (checkRoles.includes(roles[i].name) && roleGroup != 'exception') {
                    this.MY_ROLE = roles[i];
                    return this.MY_ROLE;
                }
            }
        }

        return null;
    }
    getInitials() {
        let name = this.username.charAt(0);

        if (this.firstName && this.lastName) {
            name = this.firstName.charAt(0) + this.lastName.charAt(0);
        } else if (this.firstName) {
            name = this.firstName.charAt(0);
        } else if (this.lastName) {
            name = this.lastName.charAt(0);
        }

        return name;
    }
    getFullName() {

        let name = this.username;

        if (this.firstName && this.lastName) {
            name = this.firstName + ' ' + this.lastName;
        } else if (this.firstName) {
            name = this.firstName;
        } else if (this.lastName) {
            name = this.lastName;
        }

        return name;
    }
    getRelatedItems() {
        const items = [];

        const relations = ['projects', 'companies'];
        for (let relationIndex = 0; relationIndex < relations.length; relationIndex++) {
            const relationName = relations[relationIndex];
            if (this[relationName]) {
                for (let i = 0; i < this[relationName].length; i++) {
                    const item = this[relationName][i];
                    items.push({
                        id: item.id,
                        module: relationName,
                        parentId: item.parentId ? item.parentId : (item.company ? item.company.id : null),
                        parentIds: item.parentIds ? item.parentIds : (item.company ? [item.company.id] : [])
                    });
                }
            }
        }

        return items;
    }
    setAccess(selection) {
        this.projects = [];
        this.companies = [];

        for (let i = 0; i < selection.length; i++) {
            const selectedItem = selection[i];
            if (selectedItem.module) {
                this[selectedItem.module].push(selectedItem);
            }
        }
    }
    async getSaveData() {

        let data = Object.assign({}, this);

        delete data.PERMISSIONS;
        delete data.MY_GROUP;
        delete data.MY_ROLE;
        delete data.engineFlow;

        if (data.organization) {
            data.organizationId = data.organization.id;
            delete data.organization;
        }

        if (data.assignedRealmRoles && data.assignedRealmRoles[0]) {
            const roles = [];
            for (let i = 0; i < data.assignedRealmRoles.length; i++) {
                const role = data.assignedRealmRoles[i];
                if (role.name == 'connector' && data.name) {
                    if (data.name) {
                        data.username = data.name;
                        data.email = helper.slugify(data.name) + '@eyeondata.be';
                    }
                }

                roles.push(role);
            }
            data.assignedRealmRoles = roles;
        }

        if (data.profilePicture?.id) {
            data.profilePicture = {
                id: data.profilePicture.id
            }
        }

        const oneToManyRelations = ['depot', 'vehicle'];
        for (let i = 0; i < oneToManyRelations.length; i++) {
            const relationName = oneToManyRelations[i];
            if (data.hasOwnProperty(relationName)) {
                if (data[relationName]) {
                    data[relationName + 'Id'] = data[relationName].id;
                } else {
                    data[relationName + 'Id'] = null;
                }
                delete data[relationName];
            }
        }

        const manyToManyRelations = ['skills', 'companies', 'projects', 'alarmTemplates', 'acls', 'templates'];
        for (let i = 0; i < manyToManyRelations.length; i++) {
            const relationName = manyToManyRelations[i];
            if (data.hasOwnProperty(relationName)) {
                // Map to a new array of new objects instead of mutating in place.
                // `data` is a shallow copy of `this`, so `data[relationName]` is the
                // same array reference as the live model. Mutating it here strips
                // fields (e.g. `topic`/`acc` on acls) from the array the UI is rendering,
                // which the autosave then leaves stripped because update* only returns `id`.
                data[relationName] = data[relationName].map(relatedItem => ({
                    id: relatedItem.id,
                    organizationId: data.organizationId
                }));
            }
        }

        return data;
    }
};